module.exports = __webpack_public_path__ + "static/alcancias-656c39bf8ec80f458de7fb2c299504cb.png";